import { render, staticRenderFns } from "./HomePageCarousel.vue?vue&type=template&id=2b615c07&scoped=true&"
import script from "./HomePageCarousel.vue?vue&type=script&lang=js&"
export * from "./HomePageCarousel.vue?vue&type=script&lang=js&"
import style0 from "./HomePageCarousel.vue?vue&type=style&index=0&id=2b615c07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b615c07",
  null
  
)

export default component.exports